var getEventTransfer = function getEventTransfer(data) {
  var fragmentString = data.getData('application/x-slate-fragment');
  var textContent = data.getData('text') || data.getData('text/plain') || '';
  var fragmentContent = fragmentString ? JSON.parse(decodeURIComponent(window.atob(fragmentString))) : null;
  var htmlContent = data.getData('text/html') || '';
  var hasRtfContent = data.types.includes('text/rtf');

  /**
   *  compat old version slate: if clipboard content is old version slate fragment
   *  return  html content
   */

  var files = data.files;
  var type = 'text';
  // Paste rtf format content which copied from PPT or Word or Excel as text to document
  if (hasRtfContent) {
    type = 'text';
  } else if (files.length > 0) {
    type = 'file';
  } else if (fragmentContent && Array.isArray(fragmentContent)) {
    type = 'fragment';
  } else if (htmlContent) {
    type = 'html';
  }
  return {
    text: textContent,
    html: htmlContent,
    fragment: fragmentContent,
    type: type,
    files: files
  };
};
export default getEventTransfer;